import { stringify, parse } from 'query-string';
import { ISearchBarState } from 'src/components/SearchBar';

const parseThemeId = (input?: string | string[] | null): null | number => {
  if (typeof input !== 'string') {
    return null;
  }

  const themeId = parseInt(input, 10);
  return isNaN(themeId) ? null : themeId;
}

export const parseQuery = (queryString: string): ISearchBarState => {
  const query = parse(queryString);

  return {
    searchQuery: typeof query.query === 'string' ? query.query : '',
    theme: 'theme' in query ? parseThemeId(query.theme) : null,
    searchScope: 'relevant' in query ? 'relevant' : 'all'
  };
};

export const stringifyQuery = (query: ISearchBarState): string => {
  return stringify({
    query: query.searchQuery,
    theme: query.theme ? query.theme : undefined,
    relevant: query.searchScope === 'relevant' ? null : undefined
  });
};

export const isSearchStateEqual = (a: ISearchBarState, b: ISearchBarState): boolean => (
  a.searchQuery === b.searchQuery &&
  a.theme === b.theme &&
  a.searchScope === b.searchScope
);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/SeachPage/Search.utils.ts